import api from "./axios";

export const loginBranchRequest = async (data) => {
    const res = await api.post("/login_branch", data);
    return res.data;
};
export const logoutRequest = async () => {
    const res = await api.post("/logout");
    return res.data;
};
